import { useState, useMemo } from 'react';

const usePagination = (data, rowsPerPage = 10) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(data.length / rowsPerPage);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    return data.slice(start, start + rowsPerPage);
  }, [data, currentPage, rowsPerPage]);

  // Reset to page 1 when data changes
  const reset = () => setCurrentPage(1);

  return { paginatedData, currentPage, setCurrentPage, totalPages, reset };
};

export default usePagination;